<template>
      <div class="card border-0 rounded-0 bg-white authentication-card" style="margin-top: 100px !important;">
        <div class="card-body letter-spacing">
          <h4 class="text-black fw-bold mb-0 text-center">
            Veuillez vous connecter!
          </h4>
          <Form ref="loginForm" @submit="onSubmitLogin" :validation-schema="loginSchema">
            
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Adresse mail
              </label>
              <Field name="email" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer votre email"/>
                <ErrorMessage name="email" class="text-danger"/>
            </div>

            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Mot de passe
              </label>
              <Field name="password" type="password"  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer votre mot de passe"/>
                <ErrorMessage name="password" class="text-danger"/>
            </div>
            <div
              class="d-flex align-items-center justify-content-between mb-15 mb-md-20"
            >
              <div
                class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1"
              >
                <input
                  class="form-check-input shadow-none"
                  type="checkbox"
                  id="remember-me"
                />
                <label class="form-check-label" for="remember-me">
                  Se souvenir de moi
                </label>
              </div>
              <!-- <router-link
                to="/forgot-password"
                class="forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative text-primary"
              >
                Forgot Password?
              </router-link> -->
            </div>
            <button
              class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100"
              type="submit"
            >
              Se connecter
            </button>
            
            
          </Form>
        </div>
      </div>
      <br>

      <div class="text-center mb-20 mb-md-25">
        <router-link
            to="/Regle-de-confidentialite"
            class="text-decoration-none text-white"
          >
            Règle de confidentialité
        </router-link>
      </div>

</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/services/auth';
import Swal from 'sweetalert2';

export default defineComponent({
    name: "LoginForm",
    components: {
    Form,
    Field,
    ErrorMessage,
},
  setup: () => {
    const loginSchema = Yup.object().shape({
      email: Yup.string().email("L'email est invalide").required('L\'email   est obligatoire'),
      password: Yup.string().min(5, 'Le mot de passe doit contenir au moins 8 caractères').required('Le mot de passe est obligatoire'),
    });

    const router  = useRouter();
    const store = useAuthStore();
    const submitButton = ref<HTMLButtonElement | null>(null);


    const loginForm = ref(null);
    const onSubmitLogin = async (values: any) => {
      console.log('test',values);
     // values = values as User;
      // Clear existing errors
      store.logout();
      if (submitButton.value) {
        submitButton.value.disabled = true;
      }
      // Send login request
      await store.login(values);
      const error = Object.values(store.errors);
      if (error.length === 0) {
          // Go to page after successfully login
          router.push({ name: "EcommercePage" });
      } else {
        Swal.fire({
          text: error[1] as string,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "OK",
          heightAuto: false,
          customClass: {
            confirmButton: "btn btn-sm fw-semobold btn-danger",
          },
        }).then(() => {
          store.errors = {};
        });
      }
      // eslint-disable-next-line
      // submitButton.value!.disabled = false;
      if (submitButton.value) {
        submitButton.value.disabled = false;
      }
    };
   
    return { loginSchema, onSubmitLogin, loginForm,submitButton};
  },
});
</script>